"use strict";


/**
 * @type Controller
 * @name ChangeCardInfo_Ctrl
 * @packageName changeCardInfo_dialog_ctrl.js
 *
 */
class ChangeCardInfo_Ctrl {


    constructor($scope, $mdDialog, $http) {

        $scope.$http = $http;
        this.$mdDialog = $mdDialog;

        //Attach dependicies to class root
        $scope.$mdDialog = $mdDialog;

        $scope.creditcard_name = $scope.organisationctrl.card.name;
        $scope.creditcard_expiry = $scope.organisationctrl.card.exp_month + '/' + $scope.organisationctrl.card.exp_year;

        //Close dialog
        $scope.hideDialog = () => {
            this.cancelButton();
        };
        $scope.buttonDisabled = false;



        $scope.handleCreditcardSubmit = function () {
            $scope.buttonDisabled = true;
            let data = {
                id: $scope.organisationctrl.card.id,
                name: $scope.creditcard_name,
                expiry: $scope.creditcard_expiry
            };
            this.$http.post("/billing/card/update", {'cardData': data})
                .then(() => {
                this.$mdDialog.hide();
                    $scope.buttonDisabled = false;
            })
        }

    }

    cancelButton() {
        this.$mdDialog.cancel();
    }
}


/*
 * Inject dependicies
 */
ChangeCardInfo_Ctrl.$inject = ['$scope', '$mdDialog', '$http'];


/*
 * Browsify connection: execute controller
 */
module.exports = ChangeCardInfo_Ctrl;
